import type { ReactNode } from 'react';

interface PlaceholderProps {
  readonly title: string;
  readonly description: string;
  readonly note?: string;
  readonly children?: ReactNode;
}

/**
 * Designed-shell placeholder for tabs whose reads/mutations are deferred
 * per `docs/frontend/035-frontend-app-shell-plan.md §1.2`. Renders the
 * "coming soon / wired in a follow-up task" copy without faking data.
 */
export function Placeholder({ title, description, note, children }: PlaceholderProps) {
  return (
    <div
      className="card"
      style={{
        padding: '32px 28px',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        background: 'linear-gradient(135deg,var(--butter-soft),var(--paper))',
        borderColor: 'var(--butter)',
        borderStyle: 'dashed',
      }}
    >
      <div>
        <span
          style={{
            display: 'inline-block',
            padding: '3px 10px',
            background: 'var(--ink)',
            color: 'var(--cream)',
            borderRadius: 'var(--r-full)',
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
          }}
        >
          قريباً
        </span>
      </div>
      <h2 className="h-section">{title}</h2>
      <p className="body">{description}</p>
      {note ? (
        <p className="tiny" style={{ color: 'var(--muted)', marginTop: 4 }}>
          {note}
        </p>
      ) : null}
      {children}
    </div>
  );
}
